import { Injectable } from '@angular/core';
import {
  IPaginatedResult,
  ISapDataService,
  ISort,
  ODataFilter,
  rethrowAsSapError,
  SapError,
} from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MaterialDataDomain } from 'src/app/models';
import { MaterialDataAdapter } from 'src/app/models/domain/adapters';
import { MaterialDataSetService } from 'src/generated-clients/material';

@Injectable({
  providedIn: 'root',
})
export class MaterialDataService implements ISapDataService<MaterialDataDomain, string> {
  public constructor(
    private readonly materialDataSetService: MaterialDataSetService,
    private readonly materialDataAdapter: MaterialDataAdapter
  ) {}

  public getSingle(designId: string): Observable<MaterialDataDomain> {
    return this.materialDataSetService
      .materialDataSetMaterialNumberMaterialNumberRevisionRevisionGet(
        designId,
        '',
        this.materialDataAdapter.$select
      )
      .pipe(
        rethrowAsSapError(),
        map((response) => {
          if (!response.d) {
            throw new SapError(`Unknown error`);
          }

          return this.materialDataAdapter.adaptToDomain(response.d);
        })
      );
  }

  public getMultiple(_filters?: ODataFilter): Observable<MaterialDataDomain[]> {
    throw new Error('Method not implemented.');
  }

  public update(
    _id: string,
    _entity: Partial<MaterialDataDomain>,
    _config?: { skipWrite?: boolean | undefined }
  ): Observable<MaterialDataDomain> {
    throw new Error('Method not implemented.');
  }

  public getPage(
    _page: number,
    _perPage: number,
    _sort?: Array<ISort<MaterialDataDomain>>,
    _filters?: ODataFilter,
    _expand?: string[]
  ): Observable<IPaginatedResult<MaterialDataDomain>> {
    throw new Error('Method not implemented.');
  }

  public setResponsibleUser() {
    throw new Error('Method not implemented.');
  }

  public create(_entity: Partial<MaterialDataDomain>): Observable<MaterialDataDomain> {
    throw new Error('Method not implemented.');
  }

  public delete(_id: string, _options?: unknown): Observable<void> {
    throw new Error('Method not implemented.');
  }
}
